var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as luxon from "luxon";
import { luxonTimezone } from "@mobiscroll/react";
/*
    Mobiscroll calendars render in the organization's timezone, not the one of the device.

    Without a timezone plugin Mobiscroll places events by the browser's clock, while everything else
    (luxon formatting, the backend, confirmation e-mails) uses the organization's timezone - the
    dashboard sets it as luxon's default zone at login (App.tsx). On a device whose clock zone differs
    from the hotel's (e.g. a front desk PC on UTC+1 without daylight saving) the grid and the rest of
    the app drift apart by an hour for half of the year, and every drag/click in the grid saves a
    time one hour off from what the user aimed at.

    With the plugin active Mobiscroll hands dates back as ISO strings (dataTimezone) or as its own
    timezone aware date objects, never as plain JS Dates - callbacks must go through toJsDate /
    withJsDates before comparing, formatting or storing them.
*/
luxonTimezone.luxon = luxon;
// luxon >= 2 signature of DateTime.fromObject(obj, opts) - Mobiscroll's auto detection is unreliable on minified builds
luxonTimezone.version = 2;
// Props to spread on a Mobiscroll calendar / date-time picker so it renders in luxon's default zone.
// Apps that never set a default zone (booking widget, self-service) keep the device's clock as before.
export var getCalendarTimezoneProps = function () {
    var zone = luxon.Settings.defaultZone;
    if (zone.type === 'system' || !zone.isValid)
        return {};
    return {
        timezonePlugin: luxonTimezone,
        dataTimezone: 'utc',
        displayTimezone: zone.name,
    };
};
export function toJsDate(value) {
    if (value === undefined || value === null || value === '')
        return undefined;
    if (value instanceof Date)
        return value;
    if (typeof value === 'string' || typeof value === 'number')
        return new Date(value);
    // Mobiscroll's timezone aware date objects expose the instant through valueOf()
    return new Date(+value);
}
// Copy of a Mobiscroll event with start/end as plain JS Dates
export var withJsDates = function (event) {
    if (!event)
        return event;
    return __assign(__assign({}, event), { start: toJsDate(event.start), end: toJsDate(event.end) });
};
